import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Drawer, Popconfirm,
} from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import './style.scss';
import PaymentModeForm from './PaymentModeForm';
import PaymentModeActions from '../../../../actions/configurations/paymentModeAction';

/**
 *
 */
const PaymentMode = ({
  user, getPaymentModeLoading, updatePaymentModeLoading, deletePaymentMode, deletePaymentModeLoading, getPaymentMode, paymentModeResults,
}) => {
  const [showNewPaymentMode, setShowNewPaymentMode] = useState(false);

  const [showUpdatePaymentMode, setShowUpdatePaymentMode] = useState(false);

  const [selectedPaymentMode, setSelectedPaymentMode] = useState([]);

  useEffect(() => {
    getPaymentMode('NOT_NUll');
  }, []);

  const currenciesListColumns = [
    {
      title: 'Account Name',
      render: (text, record) => (
        <Fragment>
          {record?.account_name.toProperCase()}
        </Fragment>
      ),
    },
    {
      title: 'Account Type',
      render: (text, record) => (
        <Fragment>
          {record?.account_type?.split('_')?.join(' ')?.toProperCase() || '-'}
          <br />
          <H3Text
            text={record?.bank_name?.toUpperCase() || ''}
            className="table-subscript"
          />
        </Fragment>
      ),
    },
    {
      title: 'Remarks',
      render: (text, record) => (
        <Fragment>
          {record?.remarks?.toProperCase() || '-'}
        </Fragment>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <div style={{
          textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
        }}
        >
          <div
            className="roundIconButton"
            onClick={() => {
              setShowUpdatePaymentMode(true);
              setSelectedPaymentMode(record);
            }}
          >
            <EditOutlined />
          </div>
          <Popconfirm
            placement="topRight"
            title="Are you sure you want to delete this Account?"
            onConfirm={() => deletePaymentMode({
              account_id: record?.account_id,
            }, () => {
              getPaymentMode(user?.tenant_info?.org_id);
            })}
            okText="Yes"
            cancelText="No"
          >
            <div
              className="deleteButton"
            >
              <DeleteOutlined />
            </div>
          </Popconfirm>
        </div>
      ),
    },
  ];
  return (
    <Fragment>
      <div className="account__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-18">
            <div className="account__table__wrapper">
              <div className="account__table__data hide__in-mobile">
                <Table
                  title={() => (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      {`${paymentModeResults?.length || '0'} ${'Payment Account(s)'}`}
                      <Fragment>
                        <H3Button
                          buttonType={defaultButtonTypes.BLUE_ROUNDED}
                          text="+ New Account"
                          onClick={() => setShowNewPaymentMode(true)}
                          customClass="account__header__add-button hide__in-mobile"
                        />
                      </Fragment>
                    </div>
                  )}
                  loading={getPaymentModeLoading || updatePaymentModeLoading || deletePaymentModeLoading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={currenciesListColumns}
                  dataSource={paymentModeResults || []}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showNewPaymentMode}
        width="360px"
        mask
        onClose={() => setShowNewPaymentMode(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Add New Account" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewPaymentMode(false)} />
          </div>
        </div>
        <div className="create-po__new-vendor-wrapper">
          <PaymentModeForm
            callback={() => {
              getPaymentMode(user?.tenant_info?.org_id);
              setShowNewPaymentMode(false);
            }}
          />
        </div>
      </Drawer>
      <Drawer
        title="Update Currency"
        open={showUpdatePaymentMode}
        onClose={() => setShowUpdatePaymentMode(false)}
        width="360px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Update Account" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdatePaymentMode(false)} />
          </div>
        </div>
        <PaymentModeForm
          selectedPaymentMode={selectedPaymentMode}
          callback={() => {
            getPaymentMode(user?.tenant_info?.org_id);
            setShowUpdatePaymentMode(false);
          }}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, PaymentModeReducers }) => ({
  user: UserReducers.user,
  getPaymentModeLoading: PaymentModeReducers.getPaymentModeLoading,
  updatePaymentModeLoading: PaymentModeReducers.updatePaymentModeLoading,
  deletePaymentModeLoading: PaymentModeReducers.deletePaymentModeLoading,
  paymentModeResults: PaymentModeReducers.paymentModeResults,
});

const mapDispatchToProps = (dispatch) => ({
  getPaymentMode: (accountType, callback) => dispatch(PaymentModeActions.getPaymentMode(accountType, callback)),
  deletePaymentMode: (payload, callback) => dispatch(PaymentModeActions.deletePaymentMode(payload, callback)),
});

PaymentMode.propTypes = {
  user: PropTypes.any,
  getPaymentMode: PropTypes.func,
  getPaymentModeLoading: PropTypes.bool,
  updatePaymentModeLoading: PropTypes.bool,
  deletePaymentMode: PropTypes.func,
  deletePaymentModeLoading: PropTypes.bool,
  paymentModeResults: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PaymentMode));
